export default "__VITE_ASSET__569f3d43__"